module.exports = __webpack_public_path__ + "media/images/responsive/lp/online/icon_planner_sp-1e7b099a6021db6de5b5611cd5e3f26a.png";